import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { TotalPurchaseSpendType } from "../types"

type ExpencesActivitiesType = {
  year_month: string
  location_id: string
}

export function useTotalPurchaseSpend(params: ExpencesActivitiesType) {
  const api = useApi()
  const [data, setData] = useState<TotalPurchaseSpendType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: ExpencesActivitiesType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/dashboard_purchase/get_data_dashboard", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: TotalPurchaseSpendType }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/dashboard_purchase/get_data_dashboard", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: TotalPurchaseSpendType }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}